<template>
  <div>
    <switchingcentres
      :switchingcentres="switchingCentres"
      :isloading="isLoading"
      @switchingCentreSaved="fetchSwitchingCentres()"
      @switchingCentreAdded="setLocationLength()"
      @searchInitiated="setLocationLength()"
    ></switchingcentres>
  </div>
</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import Api from "@/services/Api";
import format from "date-fns/format";
import switchingCentres from "@/components/SwitchingCentre.vue";

export default {
  components: {
    switchingcentres: switchingCentres
  },
  data() {
    return {
      isLoading: true,
      switchingCentresLength: [],
      switchingCentres: [],
    };
  },
  computed: {},
  async created() {
        this.initialize();
  },
  methods: {
    fetchSwitchingCentres() {
       this.isLoading = true,
      Api()
        .get("/switchingCentres/active")
        .then(response => {
          this.switchingCentres = response.data;
          this.isLoading = false
        });
    },
   initialize() {
     this.fetchSwitchingCentres();
    }
  }
};
</script>
